export default "__VITE_ASSET__DjWHG0Mm__"